var reportWebVitals = function reportWebVitals(onPerfEntry) {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        // eslint-disable-next-line promise/prefer-await-to-then
        import('web-vitals').then(function (_ref) {
            var getCLS = _ref.getCLS, getFID = _ref.getFID, getFCP = _ref.getFCP, getLCP = _ref.getLCP, getTTFB = _ref.getTTFB;
            getCLS(onPerfEntry);
            getFID(onPerfEntry);
            getFCP(onPerfEntry);
            getLCP(onPerfEntry);
            getTTFB(onPerfEntry);
        });
    }
};
export default reportWebVitals;
